export const SPEECH_STOP_TIMEOUT_MS = 5000;
const stops = new WeakMap();

// A disconnected SDK may never acknowledge Stop. Close once after the deadline
// and allow track cleanup, transcript saving and wallet settlement to proceed.
export function stopSpeechRecognizer(recognizer, { inputEnded } = {}) {
  if (!recognizer) return Promise.resolve();
  if (stops.has(recognizer)) return stops.get(recognizer);
  const stop = new Promise(resolve => {
    let finished = false;
    const done = () => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      try {
        recognizer.transcribed = undefined;
        recognizer.canceled = undefined;
      } catch (_) { /* Detachment must not prevent Stop from finishing. */ }
      try { recognizer.close(); } catch (_) { /* Already closed. */ }
      resolve();
    };
    const timeout = setTimeout(done, SPEECH_STOP_TIMEOUT_MS);
    const stopSdk = () => {
      if (finished) return;
      try { recognizer.stopTranscribingAsync(done, done); }
      catch (_) { done(); }
    };
    // For push input, EOF must drain queued PCM before Stop sends its own EOF.
    // The same deadline bounds both this drain and the SDK acknowledgement.
    if (inputEnded) Promise.resolve(inputEnded).then(stopSdk, stopSdk);
    else stopSdk();
  });
  stops.set(recognizer, stop);
  return stop;
}
